import {
  Card,
  Stack,
  Title,
  Container,
} from "@mantine/core";
import { UseFormReturnType, useForm } from "@mantine/form";
import { AddServiceRequest, UpdateLink, ServiceType, } from "../../types";
import BaseServiceForm from "../base_service/BaseServiceForm";
import { useEffect } from "react";

type AddServiceProps = {
  serviceTypes?: ServiceType[];
};

const AddKFHTradeService = (props: AddServiceProps) => {

  const form: UseFormReturnType<AddServiceRequest> = useForm<AddServiceRequest>({
    initialValues: {
      updateLink: {} as UpdateLink,
      signingMethod: "paci",
      onBehalfOf: undefined,
      action: "send_service_sms",
      service: {
        serviceType: "kfhtrade",
      }
    },

    validate: {
      service: {
        kycLinkWhatsappNumber: (value, values) => {
          if (values.service.customerObj?.commercial_register && !value) {
            return 'KYC Link Whatsapp Number is required for company customers';
          }
          return null;
        },
      },
    },
  });
  const preSubmitFormValues = (formValues: AddServiceRequest) => {
    const formValuesToBeSent = { ...formValues };  //I'm making a copy because I might modify things here.  I don't want the form to reflect those changes.
    formValuesToBeSent.service = { ...formValues.service };  //same
    formValuesToBeSent.updateLink = formValuesToBeSent.updateLink ?? ({} as UpdateLink);
    formValuesToBeSent.updateLink.senderID = "KFHTrade";
    return formValuesToBeSent;
  }

  useEffect(() => {
    if (!form.values.service.customerObj?.commercial_register) {
      form.setFieldValue("service.kycLinkWhatsappNumber", '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.values.service.customerObj?.id]);


  return (
    <Stack>
      <Title>Add Service</Title>
      <Card shadow="sm" p="xl" radius="md" withBorder>
        <Container>
          <BaseServiceForm form={form} serviceTypes={["kfhtrade"]} preSubmitFormValues={preSubmitFormValues} />
        </Container >
      </Card >




    </Stack >
  );
}




export default AddKFHTradeService
